import { Container, Paper, TextField, Button, Typography, Stack, Grid } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import './login.css';
import logo from '../../../assets/logo1.png';
import { Navigate } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';
import { red } from '@mui/material/colors';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentUser, setUserId } from '../../../context/sessionSlice';
import md5 from 'md5';
import Loader from "../../loader";
import constants from '../../../constants';

const validationSchema = Yup.object().shape({
    username: Yup.string().required('Username is required'),
    password: Yup.string().required('Password is required')
});

function Login() {

    const [loginFailed, setLoginFailed] = useState(null);
    const [loginMessage, setLoginMessage] = useState('');
    const dispatch = useDispatch();
    // const showLoader = useSelector(state => state.session.showLoader);
    let [showLoader, setShowLoader] = useState(false);

    const currentUser = useSelector(state => state.session.currentUser);
    let config = useSelector(state => state.session.config);
    const formik = useFormik({
        initialValues: {
            username: '',
            password: ''
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {

            // dispatch(setCurrentUser('admin'));
            // sessionStorage.setItem('userData', JSON.stringify({ username: 'admin' }));
            // return;

            setShowLoader(true);
            setLoginMessage('');

            let formData = new FormData();
            formData.append("action", "userValidation");

            try {
                const response = await axios.post(config.loginURL, formData,
                    {
                        headers: {
                            username: values.username,
                            password: md5(md5(values.password)),
                            apiKey: constants.k
                        },
                        timeout: config.apiTimeOut
                    });
                if (response.status === 200 && response.data) {
                    if (response.data.status === 'SUCCESS') {
                        if (response.data.userId) {
                            sessionStorage.setItem('userData', JSON.stringify({ username: values.username, userId: response.data.userId }));
                            dispatch(setCurrentUser(values.username));
                            dispatch(setUserId(response.data.userId));
                        } else {
                            setLoginMessage("Login not successful");
                        }
                    }

                    if (response.data.status === 'FAILURE') {
                        setLoginMessage(response.data.message);
                    }
                }
                setShowLoader(false);
            } catch (err) {
                setLoginFailed(err.response ? err.response.data : 'An error occurred');
                setShowLoader(false);
            }
        },
    });

    if (currentUser) {
        return <Navigate to="/dashboard" />
    }

    return (<>
        <Container maxWidth="lg">
            <div className="login-container">
                <Paper elevation={5} className="login-panel">
                    {/* <Typography variant="h4" gutterBottom></Typography> */}
                    <div style={{ textAlign: 'center' }}>
                        <img src={logo} style={{ width: '200px' }} alt="logo" />
                    </div>
                    <form onSubmit={formik.handleSubmit}>
                        <Stack gap={3}>
                            <TextField
                                fullWidth
                                id="username"
                                name="username"
                                label="Username"
                                size="small"
                                value={formik.values.username}
                                onChange={formik.handleChange}
                                error={formik.touched.username && Boolean(formik.errors.username)}
                                helperText={formik.touched.username && formik.errors.username}
                            />
                            <TextField
                                fullWidth
                                id="password"
                                name="password"
                                label="Password"
                                type="password"
                                size="small"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                error={formik.touched.password && Boolean(formik.errors.password)}
                                helperText={formik.touched.password && formik.errors.password}
                                margin="normal"
                            />
                            <Button color="primary" variant="contained" fullWidth type="submit" className="submit-btn" disabled={showLoader}>
                                Login
                            </Button>

                            {
                                loginFailed ? (<Typography sx={{ color: red[500], fontSize: '12px', textAlign: 'center' }}>
                                    Failed to Login
                                </Typography>) : ''
                            }

                            {
                                loginMessage ? (<Typography sx={{ color: red[500], fontSize: '12px', textAlign: 'center' }}>
                                    {loginMessage}
                                </Typography>) : ''
                            }
                        </Stack>
                    </form>
                </Paper>
            </div>
            <Loader showLoader={showLoader} />
        </Container>
    </>)
}

export default Login;
